import { StockClassType } from '@prisma/client';
import { z } from 'zod';

// cap-table's `getStockClassesByCorporationId` returns more than the picker
// needs (transactions, amountRaised). passthrough lets the surplus through;
// transform projects what we want and renames `authorizedShares` to the
// picker's `authorizedShares`.
const stockClassRowSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    type: z.nativeEnum(StockClassType),
    authorizedShares: z.number().nullable().optional(),
    hasIssuedUnits: z.boolean().nullable().optional(),
  })
  .passthrough()
  .transform((row) => ({
    id: row.id,
    name: row.name,
    type: row.type,
    authorizedShares: row.authorizedShares ?? null,
    hasIssuedUnits: row.hasIssuedUnits ?? null,
  }));

export const stockClassListSchema = z.array(stockClassRowSchema);
